import {
  OPERATORS_LOGO,
  OPERATORS_NAME
} from '@/common/const/operators.const'

const OPERATOR_LOGO_PATH = '/images/doladuj-tutaj/logo/'

export default {
  methods: {
    getOperatorLogoSrc (operator) {
      return `${OPERATOR_LOGO_PATH}${OPERATORS_LOGO[operator]}`
    },
    getOperatorName (operator) {
      return OPERATORS_NAME[operator]
    }
  }
}
